import React from 'react'
import moment from 'moment'

export class DayBlock extends React.Component {
    render() {
        let renderDayLabel = () => {
            let dayOfWeek = null

            if (this.props.arrivalDate) {
                let arrivalDate = moment(this.props.arrivalDate)

                dayOfWeek = (
                    <span className="day-number">
                        {arrivalDate.add(this.props.dayNumber - 1, 'days').format('ddd D')}
                    </span>
                )
            } else {
                dayOfWeek = (          
                    <span className="day-number">
            Day {this.props.dayNumber}
                    </span>
                )
            }

            return (
                <label>
                    {dayOfWeek}
                </label>
            )
        }

        let onAddLeg = () => {
            // subtract 1 from day number since index starts at 0
            this.props.onAddLeg(this.props.dayNumber - 1, 1)
        }

        return (
            <div className="day-block" style={{width: this.props.width + 'px'}}>
                {renderDayLabel()}
                <i className="icon-location_add" aria-hidden="true" onClick={onAddLeg}/>
                <i className="icon-delete" aria-hidden="true" onClick={this.props.onRemoveDay}/>
            </div>
        )
    }
}
